import { push } from '@lagunovsky/redux-react-router'
import moment from 'moment/moment'
import { useEffect } from 'react'
import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router'

import FormAstronaut from '../../components/Forms/FormAstronaut/FormAstronaut'
import FormChangeForgottenPassword from '../../components/Forms/FormChangeForgottenPassword/FormChangeForgottenPassword'
import Typography from '../../components/Typography/Typography'

import hocChangeForgottenPassword from './hocChangeForgottenPassword'

import gtmChangePasswordClicked from 'services/gtm/gtmChangePasswordClicked'
import useChangePassword from 'services/gtm/useChangePassword'
import './ChangeForgottenPassword.scss'

const ChangeForgottenPassword = ({
    isAuth,
    error,
    loading,
    success,
    disabled,
    changeForgottenPassword,
    setError,
    setDisabled,
}) => {
    const intl = useIntl()
    const dispatch = useDispatch()
    const { search } = useLocation()
    const params = new URLSearchParams(search)
    useChangePassword()

    const email = params.get('email')
    const validity = params.get('validity')
    const control = params.get('control')

    const validityDate = moment(validity, 'DDMMYYYYHHmmss')
    const now = moment()
    const isInvalid = validityDate.isBefore(now)

    useEffect(() => {
        if (isInvalid) {
            setError({ cause: 'notValid' })
            setDisabled(true)
        }
    }, [validity])

    useEffect(() => {
        if (isAuth) dispatch(push('/user-profile'))
    }, [isAuth])

    const handleSubmit = (formValues) => {
        gtmChangePasswordClicked()
        changeForgottenPassword({ ...formValues, email, validity, control })
    }

    return (
        <Container fluid className={'d-flex flex-column'}>
            <div className={'change-forgotten-password-page d-flex flex-column'}>
                <Typography variant={'h2'}>
                    {intl.formatMessage({ id: 'forms.changeForgottenPassword.title' })}
                </Typography>
                <div className={'change-forgotten-password-page--content d-flex'}>
                    <FormAstronaut />
                    <FormChangeForgottenPassword
                        loading={loading || disabled}
                        email={email}
                        handleSubmit={handleSubmit}
                    />
                </div>
            </div>
        </Container>
    )
}

export default hocChangeForgottenPassword(ChangeForgottenPassword)
